import { render, staticRenderFns } from "./StaffInvite.vue?vue&type=template&id=5aee52dc&scoped=true&"
import script from "./StaffInvite.vue?vue&type=script&lang=js&"
export * from "./StaffInvite.vue?vue&type=script&lang=js&"
import style0 from "./StaffInvite.vue?vue&type=style&index=0&id=5aee52dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aee52dc",
  null
  
)

export default component.exports